import { Component, input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';

export interface CheckboxOption {
  label: string;
  value: string;
  icon?: string;
}

@Component({
  selector: 'app-checkbox-group',
  standalone: true,
  imports: [CommonModule, CheckboxModule, FormsModule],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxGroupComponent),
    multi: true
  }],
  templateUrl: './checkbox-group.component.html'
})
export class CheckboxGroupComponent implements ControlValueAccessor {
  options = input.required<CheckboxOption[]>();
  cols    = input<2 | 3 | 4>(3);
  
  value: string[] = [];
  onChange = (v: any) => {};
  onTouched = () => {};

  writeValue(val: string[]) { this.value = val || []; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }

  onCheck(val: string[]) {
    this.value = val;
    this.onChange(val);
  }

  getGridClass(): string {
    const map = { 2: 'grid-cols-2', 3: 'grid-cols-2 sm:grid-cols-3', 
                  4: 'grid-cols-2 sm:grid-cols-4' };
    return 'grid gap-4 mt-1 ' + map[this.cols()];
  }
}
